import React, { useCallback } from 'react'
import { FormRow } from '@/components/changeRequests'
import context from '@/context'
import { useCoupledProps } from '@/components/changeRequests/useCoupledProps'

const personTypes = {
  enumName: 'PersonTypes',
  values: [1, 9, 10]
}

export function PersonSelection ({ readonly, personId, target }) {
  const { value: personType, onChange: onTypeChange } = useCoupledProps('personType', ['person'])

  const dataSource = useCallback((req) => (personType || 1) === 1
    ? context.api.individualService.getPersons(exceptTarget(req, personId))
    : context.api.institutionService.getPersons(exceptTarget(req, personId)), [personId, personType])

  return (
    <React.Fragment>
      <FormRow label='Institutions.PersonTypes' name='personType' inputType='enum' onChange={onTypeChange} target={target} inputProps={personTypes} readonly={readonly} required />
      {personType !== 10 ? <FormRow
        key={personType}
        name='person' inputType='dropdown'
        label={(personType || 1) === 1 ? 'Institutions.RelatedIndividual' : 'Institutions.RelatedInstitution'}
        dataSource={dataSource}
        required={personType === 1 || personType === 9}
        target={target}
        readonly={readonly} /> : null}
    </React.Fragment>
  )
}

function exceptTarget (req, personId) {
  if (!req) req = {}
  if (personId) {
    if (!req.filter) req.filter = { filters: [] }
    req.filter.logic = 'and'
    req.filter.filters.push({ field: 'id', operator: 'neq', value: personId })
  }
  return req
}



// WEBPACK FOOTER //
// ./src/components/demographics/personSelection.js